import React, { useState, useEffect } from "react";
import "./common.scss";
import GuideLine from "./GuideLine";
import { useData } from "../utils/dataProvider";
export default function Layout({ children }) {
    const { auto, setAuto } = useData();
    return (
        <div className='layout'>
            <div className='header-container'>
                <div className='headline-1'>In wenigen Minuten zum Angebot</div>
                {auto ? (
                    <div className='headline-2'>
                        Ihr <b>{auto}</b> Tarif
                    </div>
                ) : (
                    <div className='headline-2'>EMOVER24 Tarifrechner</div>
                )}
            </div>
            <GuideLine></GuideLine>
            <div className='formular-container'>{children}</div>
        </div>
    );
}
